import { render, staticRenderFns } from "./PoiModal.vue?vue&type=template&id=1a368f4d"
import script from "./PoiModal.vue?vue&type=script&lang=js"
export * from "./PoiModal.vue?vue&type=script&lang=js"
import style0 from "./PoiModal.vue?vue&type=style&index=0&id=1a368f4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports